export default __webpack_public_path__ + "static/media/icon-prescritor.36f959a6.svg";